import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import "./registration.css";

function Test() {
  const [formData, setFormData] = useState({ 
    email: '',
    name: '',
    permanentAddress: '',
    contactNo: '',
    gcontactNo: '',
    correspondentAddress: '',
    nicPassportNo: '',
    academicQualification: 'Ordinary Level',
    selectedCourse: 'Ophthalmic Optician',
    courseType: 'Full time',
    educationFile: null,
    termConditionFile: null,
    paymentSlipFile: null,
    photoFile: null,
  });


  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);





  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError(null);

    try {
      const storage = getStorage();
      
      // Generate unique filenames with timestamps
      const timestamp = Date.now();
      



      // Upload education certificate file
      let educationUrl = null;

// Upload only if the course requires the file
if (formData.educationFile) {
  const educationFileName = `education_${timestamp}_${formData.educationFile.name}`;
  const educationRef = ref(storage, `courseRegistration/${educationFileName}`);
  await uploadBytes(educationRef, formData.educationFile);
  educationUrl = await getDownloadURL(educationRef);
}

      // const educationFileName = `education_${timestamp}_${formData.educationFile.name}`;
      // const educationRef = ref(storage, `courseRegistration/${educationFileName}`);
      // await uploadBytes(educationRef, formData.educationFile);
      // const educationUrl = await getDownloadURL(educationRef);




      // Upload terms and conditions file
      const termsFileName = `terms_${timestamp}_${formData.termConditionFile.name}`;
      const termsRef = ref(storage, `courseRegistration/${termsFileName}`);
      await uploadBytes(termsRef, formData.termConditionFile);
      const termConditionUrl = await getDownloadURL(termsRef);

      // Upload payment slip
      const paymentFileName = `payment_${timestamp}_${formData.paymentSlipFile.name}`;
      const paymentRef = ref(storage, `courseRegistration/${paymentFileName}`);
      await uploadBytes(paymentRef, formData.paymentSlipFile);
      const paymentSlipUrl = await getDownloadURL(paymentRef);

      // Upload photo
      const photoFileName = `photo_${timestamp}_${formData.photoFile.name}`;
      const photoRef = ref(storage, `courseRegistration/${photoFileName}`);
      await uploadBytes(photoRef, formData.photoFile);
      const photoUrl = await getDownloadURL(photoRef);

      // Prepare data for Firestore
      const registrationData = {
        email: formData.email,
        name: formData.name,
        permanentAddress: formData.permanentAddress,
        contactNo: formData.contactNo,
        gcontactNo: formData.gcontactNo,
        correspondentAddress: formData.correspondentAddress,
        nicPassportNo: formData.nicPassportNo,
        academicQualification: formData.academicQualification,
        selectedCourse: formData.selectedCourse,
        courseType: formData.courseType,
        educationUrl,
        termConditionUrl,
        paymentSlipUrl,
        photoUrl,
        status: 'pending',
        createdAt: serverTimestamp(),
      };

      // Save to Firestore
      await addDoc(collection(db, 'courseRegistration'), registrationData);

      // Prepare email data
      const emailData = {
        email: formData.email,
        name: formData.name,
        permanentAddress: formData.permanentAddress,
        contactNo: formData.contactNo,
        gcontactNo: formData.gcontactNo,
        correspondentAddress: formData.correspondentAddress,
        nicPassportNo: formData.nicPassportNo,
        academicQualification: formData.academicQualification,
        selectedCourse: formData.selectedCourse,
        courseType: formData.courseType,
        educationUrl,
        termConditionUrl,
        paymentSlipUrl,
        photoUrl,
      };

      // Send email
      await emailjs.send(
        'service_gahawkc',
        'template_tz75vnj',
        emailData,
        'SmoVT3u-6A8Q9aI9_'
      );

      // Reset form after successful submission
      setFormData({ 
        email: '',
        name: '',
        permanentAddress: '',
        contactNo: '',
        gcontactNo: '',
        correspondentAddress: '',
        nicPassportNo: '',
        academicQualification: 'Ordinary Level',
        selectedCourse: 'Ophthalmic Optician',
        courseType: 'Full time',
        educationFile: null,
        termConditionFile: null,
        paymentSlipFile: null,
        photoFile: null,
      });

      alert('Registration submitted successfully!');
    } catch (err) {
      console.error('Failed to submit registration:', err);
      setSubmitError('Failed to submit registration. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };





  


  return (
    <div className="course-registration">
      <h2>Eye Care Institute - Course Registration</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Name:</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Permanent Address:</label>
          <input
            type="text"
            name="permanentAddress"
            placeholder="Enter your permanent address"
            value={formData.permanentAddress}
            onChange={handleChange}
            required
          />
        </div>
        
        <div>
          <label>Contact No:</label>
          <input
            type="text"
            name="contactNo"
            placeholder="Enter your contact no"
            value={formData.contactNo}
            onChange={handleChange}
            required
            maxLength="10"
            pattern="\d{10}"
            title="Please enter a valid 10-digit contact number."
          />
        </div>


        <div>
          <label>Guardian's Contact No:</label>
          <input
            type="text"
            name="gcontactNo"
            placeholder="Enter Guardian's Contact No"
            value={formData.gcontactNo}
            onChange={handleChange}
            required
            maxLength="10"
            pattern="\d{10}"
            title="Please enter a valid 10-digit contact number."
          />
        </div>



        <div>
          <label>Correspondent Address:</label>
          <input
            type="text"
            name="correspondentAddress"
            placeholder="Enter your correspondent address"
            value={formData.correspondentAddress}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>NIC / Passport No:</label>
          <input
            type="text"
            name="nicPassportNo"
            placeholder="Enter your NIC or Passport no"
            value={formData.nicPassportNo}
            onChange={handleChange}
            required
          />
        </div>
        {/* <div>
          <label>Academic Qualification:</label>
          <select
            name="academicQualification"
            value={formData.academicQualification}
            onChange={handleChange}
            required
          >
            <option value="Ordinary Level">Ordinary Level</option>
            <option value="Advanced Level">Advanced Level</option>
            <option value="Work Experience">Work Experience</option>
          </select>
        </div> */}

<div>
  <label>Academic Qualification:</label>
  <select
    name="academicQualification"
    value={formData.academicQualification}
    onChange={handleChange}
    required
  >
    {formData.selectedCourse === "Ophthalmic Optician" ? (
      <>
        <option value="Ordinary Level">Ordinary Level</option>
        <option value="Work Experience">Work Experience</option>
      </>
    ) : (
      <>
        <option value="Ordinary Level">Ordinary Level</option>
        <option value="Advanced Level">Advanced Level</option>
        <option value="Work Experience">Work Experience</option>
      </>
    )}
  </select>
</div>
        

        <div>
          <label>Select the course:</label>
          <select
            name="selectedCourse"
            value={formData.selectedCourse}
            onChange={handleChange}
            required
          >
            <option value="NVQ Level 3 ( RPL )">NVQ Level 3 ( RPL )</option>
            <option value="Ophthalmic Optician">Ophthalmic Optician (NVQ Level 3)</option>
            <option value="Certificate in Ophthalmic Assistant">Certificate in Ophthalmic Assistant</option>
            <option value="Diploma in Optometry">Diploma in Optometry (NVQ Level 5)</option>
            <option value="Higher Diploma in Optometry">Higher Diploma in Optometry (NVQ Level 6)</option>
            <option value="Bachelor of Optometry (B.Optom)">Bachelor of Optometry (B.Optom)</option>
        
            {/* <option value="NVQ Level 5">NVQ Level 5</option> */}
          </select>
        </div>

        
        <div>
          <label>How do you want to follow this course?</label>
          <select
            name="courseType"
            value={formData.courseType}
            onChange={handleChange}
            required
          >
            <option value="Full time">Full time</option>
            <option value="Part time">Part time</option>
          </select>
        </div>




{/* {formData.selectedCourse !== "NVQ Level 3" &&
 formData.selectedCourse !== "Ophthalmic Optician" && (
  <div>
    <label>Upload O/L or A/L Result Sheet :</label>
    <input
      type="file"
      name="educationFile"
      style={{ all: "unset", display: "block", border: "2px solid blue" }}
      accept=".pdf, .jpg, .jpeg, .png"
      onChange={handleFileChange}
      required 
    />
  </div>
)} */}

{/* {formData.selectedCourse !== "" && ( */}
  <div>
    <label>
      {formData.selectedCourse === "Bachelor of Optometry (B.Optom)"
        ? "Upload Diploma/Higher Diploma Certificate:"
        : formData.selectedCourse === "NVQ Level 3 ( RPL )"
        ? "Upload Work Experience or O/L Certificate:"
        : formData.selectedCourse === "Ophthalmic Optician"
        ? "Upload Work Experience or O/L Certificate:"
        : "Upload O/L or A/L Result Sheet:"
        
        }
    </label>

    <input
      type="file"
      name="educationFile"
      style={{ all: "unset", display: "block", border: "2px solid blue" }}
      accept=".pdf,.jpg,.jpeg,.png"
      onChange={handleFileChange}
      required
    />
  </div>
{/* )} */}




          <div>
        <label>Upload your National Identity Card copy (Front & rear side):</label>
          <input
            type="file"
            name="termConditionFile" 

            style={{ all: 'unset', display: 'block', border: '2px solid blue' }}



            accept=".pdf, .jpg, .jpeg, .png"
            onChange={handleFileChange}
            required
          />
        </div>


        {/* <div>
          <label>Upload payment slip (Rs. 2000) :</label>
          <input
            type="file"
            name="paymentSlipFile"

            style={{ all: 'unset', display: 'block', border: '2px solid blue' }}



            accept=".pdf, .jpg, .jpeg, .png"
            onChange={handleFileChange}
            required
          />
        </div> */}


        <div>
  <label>
    Upload payment slip (
    Rs.{" "}
    {formData.selectedCourse === "Bachelor of Optometry (B.Optom)"
      ? "7500"
      : "2000"}
    ) :
  </label>

  <input
    type="file"
    name="paymentSlipFile"
    style={{
      all: "unset",
      display: "block",
      border: "2px solid blue",
    }}
    accept=".pdf, .jpg, .jpeg, .png"
    onChange={handleFileChange}
    required
  />
</div>






        <div>
          <label>upload a high-resolution passport-size photograph with a white background (Scanned hard copies are not acceptable) :</label>
          <input
            type="file"
            name="photoFile"

          style={{ all: 'unset', display: 'block', border: '2px solid blue' }}


            accept=".pdf, .jpg, .jpeg, .png"
            onChange={handleFileChange}
            required
          />
        </div>


        <div>
        <button 
            className="reg-submit-button" 
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>


      <div className="bank-details-container">
        <h2 className="bank-details-heading">Bank Details</h2>
        <div className="bank-detail-item">
          <strong>Account No</strong> <span> : 055010165128</span>
        </div>
        <div className="bank-detail-item">
          <strong>Account Name</strong> <span> : EYE CARE INSTITUTE (PVT) LTD</span>
        </div>
        <div className="bank-detail-item">
          <strong>Bank</strong> <span> : Hatton National Bank</span>
        </div>
        <div className="bank-detail-item">
          <strong>Branch</strong> <span> : Borella</span>
        </div>
      </div>



    </div>
  );
}

export default Test;
